import { StyleSheet, Text, View, Modal, ActivityIndicator } from 'react-native'
import React from 'react'
import { useFonts } from 'expo-font';
import { Manrope_600SemiBold } from '@expo-google-fonts/manrope';
import {
    Poppins_700Bold,
} from '@expo-google-fonts/poppins';
import {
    LabledTextField,
    ActionButton,
    HaveAccount
} from '../SharedWidgets/LoginAndSignup';

import { navStack } from '../../Types/uitypes'
import { useNavigation } from "@react-navigation/native";
import { useSignUpStore } from './SignUpStore';
import OtpModalView from '../SharedWidgets/LoginAndSignup/OtpModalView';



export default function SignupScreen() {

    const navigation = useNavigation<navStack>();

    const {
        fullName,
        email,
        password,
        confirmedPassword,
        showPassword,
        showConfirmedPassword,
        setFullName,
        setEmail,
        setPassword,
        setConfirmedPassword,
        toggleShowConfirmedPassword,
        toggleShowPassword,
        handleSignupBtn,
        showModal,
        otp,
        setOtp,
        toggleModel,
        modalLoading,
        sendOtp,
        toggleLoading,
        verfiyOtp,
        otpVerified,
        toggleOtpVerified,
        hideActivityIndicator,
        toggleActivityIndicator
    } = useSignUpStore();



    const [fontsLoaded] = useFonts({
        Poppins_700Bold,
        Manrope_600SemiBold
    });

    if (!fontsLoaded) return null;


    async function hanldeOtpVerification() {
        console.log(otp);
        toggleLoading();
        verfiyOtp(() => {
            toggleOtpVerified();
            toggleModel();
            toggleActivityIndicator();
            handleSignupBtn((user) => {
                location.href = "/";
            })
        })

    }

    async function msendOtp() {
        if (otpVerified) {
            toggleActivityIndicator();

            handleSignupBtn((user) => {
                location.href = "/";
            })
        } else {
            if (email != "") {

                toggleActivityIndicator();

                sendOtp(() => {
                    toggleActivityIndicator();
                    toggleModel();
                })
            } else {
                window.alert("Email Cant be Empty");
            }
        }


    }

    return (
        <View style={styles.root}>

            <View>
                <Text style={{ fontFamily: 'Poppins_700Bold', fontSize: 24, textAlign: "center" }}>
                    Create an account
                </Text>

                <Text style={{ fontFamily: 'Poppins_700Bold', fontSize: 14, textAlign: "center", color: "#343434" }}>Connect with your friends today!</Text>
            </View>

            <LabledTextField hint='John Doe'
                title='Full Name'
                value={fullName}
                onValueChange={setFullName}
            />

            <LabledTextField
                hint='example@gmail.com'
                title='Email'
                value={email}
                onValueChange={setEmail}
            />

            <LabledTextField
                hint='Enter Your Password'
                title='Password'
                useEye={true}
                value={password}
                eyeState={showPassword}
                onValueChange={setPassword}
                toggleEye={toggleShowPassword}

            />
            <LabledTextField
                hint='Confirm Password'
                title='Confirm Password'
                useEye={true}
                value={confirmedPassword}
                eyeState={showConfirmedPassword}
                onValueChange={setConfirmedPassword}
                toggleEye={toggleShowConfirmedPassword}

            />

            <ActionButton label='SIGN UP' onClick={msendOtp} />
            <HaveAccount messageText='Already have an account' actionText='Login' actionTextPress={() => navigation.navigate("LoginScreen")} />
            {hideActivityIndicator && <View style={styles.container}>
                <ActivityIndicator size="large" color="#007AFF" />
            </View>}
            <Modal
                visible={showModal}
                transparent
                animationType="slide"
            >
                <View style={styles.modalOverlay}>
                    <View style={styles.modalContainer}>
                        <OtpModalView
                            value={otp}
                            onValueChange={setOtp}
                            hideModel={toggleModel}
                            handleVerifyOptp={hanldeOtpVerification}
                            loading={modalLoading}
                        />
                    </View>
                </View>

            </Modal>

        </View>
    )
}

const styles = StyleSheet.create({
    root: {
        backgroundColor: "white",
        flex: 1,
        gap: 12,
        paddingHorizontal: 12,
        paddingVertical: 12,

    },
    modalOverlay: {
        flex: 1,
        justifyContent: "flex-end", // push to bottom
        backgroundColor: "rgba(0,0,0,0.5)",
    },

    modalContainer: {
        height: "50%", // 👈 Half screen
        backgroundColor: "white",
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
        padding: 20,
    },
    container: {
        justifyContent: 'center',
        alignItems: 'center',
    },
})